// extracted by mini-css-extract-plugin
export default {"content":"PreOverquotainfo__content--3ZL4y"};